import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import { closest } from 'next/javascripts/modules/dom';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import { Option } from 'next/javascripts/components/select-list';

Component('tr-todo-moveform', {
  mixins: [eventListenerMixin],

  ready() {
    this.selectProjects = this.querySelector('.select-projects');
    this.selectList = this.querySelector('.select-lists');
    this.selectTodo = this.querySelector('.select-todos');
    this.$btn = $('button[type=submit]', this);

    this.initSelectList();
    this.selectProjects.addEventListener('tr-combo-select-field:change', this.initSelectList.bind(this));

    if (this.selectTodo) {
      this.selectList.addEventListener('tr-combo-select-field:change', this.initSelectTodo.bind(this));
      this.selectList.addEventListener('tr-combo-select-field:change', this.modifyTodoRemote.bind(this));
    }

    $(this).on('ajax:success', '.tr-form', this.handleSuccess.bind(this));
    $(this).on('ajax:error', '.tr-form', this.showListEmptyError.bind(this));
    $(this).on('ajax:beforeSend', '.tr-form', this.validateForm.bind(this));
  },

  initSelectList() {
    const projectGuid = this.selectProjects.getValue();
    const { selectedOptions } = this.selectProjects;
    const { listName } = this.selectList.dataset;
    if (!projectGuid || !selectedOptions) return;

    if (!projectGuid) return;
    if (this.selectTodo) this.cleanSelectTodo();

    $.ajax({
      url: `/projects/${projectGuid}/lists/uncompleted/`,
      type: 'get',
      dataType: 'json',
      success: (result) => {
        const options = result.map(o => new Option(o.label, o.guid, { 'search-key': `${o.label}${o.key}` }));
        this.selectList.reset();
        this.selectList.dataProvider.options = options;
        this.selectList.list.setOptions(options);
        const shouldSelected = options.filter(option => option.text === listName);
        if (shouldSelected) this.selectList.selectOption(shouldSelected[0]);

        if (this.selectTodo) this.initSelectTodo();
      },
    });
  },

  initSelectTodo() {
    const {
      teamGuid, parentName, currentTodoId,
    } = this.selectTodo.dataset;
    const projectGuid = this.selectProjects.getValue();
    const listGuid = this.selectList.getValue();
    const data = {
      project_guid: projectGuid,
      todolist_guid: listGuid,
      current_todo_id: currentTodoId,
      except_descendants: true,
      per: 10,
    };
    if (!projectGuid) return;
    if (!listGuid) return;
    $.ajax({
      url: `/teams/${teamGuid}/todos`,
      type: 'get',
      dataType: 'json',
      data,
      success: (result) => {
        const options = result.options.map(opt => Option.fromJSON(opt));
        this.selectTodo.reset();
        this.selectTodo.dataProvider.options = options;
        this.selectTodo.list.setOptions(options);
        const shouldSelected = options.filter(option => option.text === parentName);
        if (shouldSelected) this.selectTodo.selectOption(shouldSelected[0]);
      },
    });
  },

  cleanSelectTodo() {
    this.selectTodo.reset();
  },

  modifyTodoRemote() {
    const { currentTodoId } = this.selectTodo.dataset;
    let { url } = JSON.parse(this.selectTodo.getAttribute('remote'));
    const { searchKey } = JSON.parse(this.selectTodo.getAttribute('remote'));
    const projectGuid = this.selectProjects.getValue();
    const listGuid = this.selectList.getValue();
    const baseUrl = url.slice(0, url.indexOf('?'));
    url = `${baseUrl}?except_descendants=true&project_guid=${projectGuid}&todolist_guid=${listGuid}&current_todo_id=${currentTodoId}`;
    this.selectTodo.dataProvider.remote.url = url;
    this.selectTodo.setAttribute('remote', JSON.stringify({ url, searchKey }));
  },

  validateForm(e, xhr) {
    if (!this.selectProjects.getValue()) {
      this.showProjectEmptyError();
      xhr.abort();
      e.stopPropagation();
    }
  },

  showProjectEmptyError() {
    closest(this.selectProjects, '.tr-form-input').classList.add('tr-form-input--invalid');
    this.selectProjects.querySelector('.mdc-select-helper-text').innerText = '请选择项目';
  },

  showListEmptyError() {
    closest(this.selectList, '.tr-form-input').classList.add('tr-form-input--invalid');
    this.selectList.querySelector('.mdc-select-helper-text').innerText = '请选择清单';
  },

  handleSuccess(e, result) {
    if (!result.success) return;
    const pageOpened = document.querySelector('.tr-page[opened]');
    const todoPage = document.querySelector('tr-todo-page');
    const inSameProject = todoPage.projectGuid === result.proj_guid;
    let successTpl;
    if (inSameProject) {
      successTpl = '<div class="page-tip action hide">移动完成</div>';
    } else {
      successTpl = `
        <div class="page-tip action hide">
            移动完成，这个条目已被移动到 <em>{{ proj_name | encodeHtml }}</em> 中，
            <a data-nocache data-stack data-stack-root
                ${pageOpened ? '' : 'data-parent-name="{{ proj_name | encodeHtml }}"'}
                ${pageOpened ? '' : 'data-parent-url="{{ proj_url }}"'}
                href="{{ ${pageOpened ? 'proj_url' : 'url'} }}">
              ${pageOpened ? '' : '，现在就去查看 →'}
            </a>
        </div>
      `;
    }
    const $todoPage = $(todoPage);
    const $tip = $(window.simple.tpl(successTpl, result));
    $todoPage.prepend($tip);
    $tip.slideDown();
    if (inSameProject) {
      setTimeout(() => {
        $tip.slideUp();
      }, 3000);
    } else {
      $todoPage.addClass('with-disable-mask');
    }

    window.tower.todoSubject.next('move', {
      id: result.todo_id,
      guid: result.todoGuid,
      projectGuid: result.proj_guid,
      originalProjectGuid: result.originalProjectGuid,
      todolistGuid: result.todolist_guid,
      todolistName: result.todolist_name,
      rowData: result.rowData,
      isSubTodo: result.is_sub_todo,
      isBatchTask: false,
    });
  },

  disconnected() {
    this.stopListening();
  },
});
